<template>
  <div
    class="pointer-events-none fixed z-200 flex w-80 max-w-[min(20rem,calc(100vw-2rem-env(safe-area-inset-left)-env(safe-area-inset-right)))] flex-col gap-2 top-[calc(env(safe-area-inset-top)+1rem)] right-[calc(env(safe-area-inset-right)+1rem)] sm:top-[calc(env(safe-area-inset-top)+1.5rem)] sm:right-[calc(env(safe-area-inset-right)+1.5rem)]"
  >
    <transition-group name="toast" tag="div">
      <div
          v-for="t in toastStore.list"
          :key="t.id"
          :class="[
          'pointer-events-auto px-4 py-2 rounded shadow-lg flex items-center space-x-2 cursor-pointer',
          {
            'bg-green-500 text-white':  t.type === 'success',
            'bg-red-500 text-white':    t.type === 'error',
            'bg-yellow-500 text-black': t.type === 'warning',
            'bg-blue-500 text-white':   t.type === 'info',
          }
        ]"
          @click="toastStore.remove(t.id)"
      >
        <component :is="icons[t.type]" class="h-5 w-5 shrink-0" />
        <span>{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { useToastStore } from '@/stores/toast'
import {
  CheckCircleIcon,
  AlertCircleIcon,
  AlertTriangleIcon,
  InfoIcon
} from 'lucide-vue-next'

const toastStore = useToastStore()

const icons = {
  success: CheckCircleIcon,
  error:   AlertCircleIcon,
  warning: AlertTriangleIcon,
  info:    InfoIcon,
}
</script>

<style>
.toast-enter-from   { opacity: 0; transform: translateY(-10px) }
.toast-enter-active { transition: all .2s ease-out }
.toast-leave-to     { opacity: 0; transform: translateY(-10px) }
.toast-leave-active { transition: all .2s ease-in }
</style>
